import {FILE_TABLE_DATA, LOADER_STATUS } from "./constants";

export const initialState = {
    loaderStatus: false, 
    fileTableData:[],
};
  
  /* eslint-disable default-case, no-param-reassign */
  const gstr1NewFileReducer = (state = initialState, action) =>{
      switch (action.type) {
        
        case LOADER_STATUS:
          return {
            ...state,
            loaderStatus:action.loaderStatus
          }
          case FILE_TABLE_DATA:
            return {
              ...state,
              fileTableData:action.fileTableData
            }
        default:
          return state;
      }
    };
  
  export default gstr1NewFileReducer;